(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_cro-badges"] && !Shopify.designMode) return;
  try {
    (() => {
    const BADGE_MAX_FRAC = 0.15; // 15% of visible image height

    function setOverlay(container) {
        const layer = container.querySelector('.media-gallery__badge-layer');
        const img   = container.querySelector('img.product-media__image');
        if (!layer || !img) return;

        if (!img.naturalWidth || !img.naturalHeight) {
            img.addEventListener('load', () => setOverlay(container), { once: true });
            return;
        }

        const cw = container.clientWidth;
        const ch = container.clientHeight;
        if (cw <= 0 || ch <= 0) { requestAnimationFrame(() => setOverlay(container)); return; }

        // Fit math (object-fit: contain)
        const iw = img.naturalWidth, ih = img.naturalHeight;
        const scale = Math.min(cw / iw, ch / ih);
        const fitH  = ih * scale;

        // Vertically center letterbox gap
        const topGap = Math.max(0, (ch - fitH) / 2);
        const botGap = Math.max(0, ch - fitH - topGap);

        // Keep full width; ONLY trim vertically so .badge-pos-* rules handle X/Y
        layer.style.left   = '0px';
        layer.style.right  = '0px';
        layer.style.top    = topGap + 'px';
        layer.style.bottom = botGap + 'px';

        // Cap size with a CSS var (no transforms)
        const cap = Math.max(24, Math.round(fitH * BADGE_MAX_FRAC)); // min 24px
        layer.style.setProperty('--badge-max', cap + 'px');
    }

    function wire(container) {
        if (container.dataset.badgePosWired) return;
        if (!container.querySelector('.media-gallery__badge-layer')) return;
        if (!container.querySelector('.cro-badge')) return;
        container.dataset.badgePosWired = '1';

        const img = container.querySelector('img.product-media__image');
        if (img && !img.complete) img.addEventListener('load', () => setOverlay(container), { once: true });

        setOverlay(container);

        // Update when layout/slide changes or resize occurs
        new MutationObserver(() => setOverlay(container))
            .observe(container, { childList: true, subtree: true, attributes: true });

        container.addEventListener('load', e => {
            if (e.target && e.target.matches('img.product-media__image')) setOverlay(container);
        }, true);

        window.addEventListener('resize', () => setOverlay(container));
    }

    function scan(root = document) {
        if (!root.querySelector('.media-gallery__badge-layer .cro-badge')) return;
        root.querySelectorAll('.product-media').forEach(wire);
    }

    document.addEventListener('DOMContentLoaded', () => scan());
    document.addEventListener('shopify:section:load',   e => scan(e.target));
    document.addEventListener('shopify:section:select', e => scan(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll("product-form-component").forEach((e) => {
      if (e.dataset.showPriceOnButtons == "true") {
        const form = e.querySelector(":scope input")?.form;
        if (form) {
          const originalTexts = new Map();
          const updatePrice = () => {
            const currency = form.querySelector(":scope input[name='id'], :scope input[name='items[main][id]']").dataset.currency;
            const price = [...form.querySelectorAll(":scope input[name='id'], :scope input[name='items[main][id]'], :scope input:checked")]
              .reduce((total, input) => total + (input.dataset.price ? parseInt(input.dataset.price) : 0),
                0);
            const priceStr = new Intl.NumberFormat(undefined, {
              style: "currency",
              currency,
            }).format(price / 100.0);
            form.querySelectorAll(":scope .add-to-cart-text__content, :scope .shopify-payment-button__button").forEach((label) => {
              if (label.closest("button").disabled) return;
              let originalText = originalTexts.get(label);
              if (!originalText) {
                originalText = label.innerHTML;
                originalTexts.set(label, originalText);
              }
              const newLabel = `${priceStr} - ${originalText}`;
              if (label.innerHTML != newLabel)
                label.innerHTML = newLabel;
            });
          };
          const observer = new MutationObserver(updatePrice);
          observer.observe(form, { attributes: true, childList: true, subtree: true });
          updatePrice();
        }
      }
    });
  });

  document.addEventListener("variant:update", function(variant) {
    document.querySelectorAll("product-form-component").forEach((e) => {
      if (e.dataset.showPriceOnButtons == "true") {
        const form = e.querySelector(":scope input")?.form;
        form.querySelectorAll(":scope input[name='items[main][id]']").forEach((main) => {
          main.dataset.price = `${variant?.detail?.resource?.price || ""}`;
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-installation"] && !Shopify.designMode) return;
  try {
    function setupBlock(block) {
    const group = block.dataset.group;
    const form = block.querySelector(":scope input")?.form;
    if (!form) return;
    const formFields = buy_buttons_make_form_multi(form);
    const mainCheckbox = block.querySelector("input[type='checkbox']");
    const mainPrice = parseInt(mainCheckbox.dataset.price);
    const mainQuantity = formFields.quantity;
    const toggle = form.querySelector(`:scope input[name='${group}']`);
    const toggleLabel = form.querySelector(`:scope label[for='${group}']`);
    const quantity = form.querySelectorAll(`:scope input[name='items[${group}][quantity]']`);
    let price = mainPrice;
    const installs = Array.from(form.querySelectorAll(":scope input[name^='items[install-'][name$='[quantity]']")).map((i) => {
      const checkbox = form.querySelector(`:scope #${i.dataset.checkbox}`);
      const label = form.querySelector(`:scope label[for='${i.dataset.label}'] span`);
      const price = checkbox.dataset.installPrice ? parseInt(checkbox.dataset.installPrice) : 0;
      return [i, checkbox, label, price];
    });
    const updateQuantities = () => {
      installs.forEach(([i, checkbox]) => {
        if (toggle.checked && checkbox.checked) {
          i.value = mainQuantity.value;
        } else {
          i.value = 0;
        }
      });
    };
    toggle.addEventListener("change", updateQuantities);
    document.addEventListener("quantity-selector:update", (e) => {
      if (e.target == mainQuantity) updateQuantities();
    });
    installs.forEach(([i, checkbox, label, childPrice]) => {
      let childLabel = null;
      checkbox.addEventListener("change", function () {
        if (checkbox.checked && toggle.checked) {
          i.value = mainQuantity.value;
        } else {
          i.value = 0;
        }
        if (checkbox.checked) {
          if (label) childLabel = toggleLabel.appendChild(label.cloneNode(true));
          price += childPrice;
        } else {
          if (label && childLabel) toggleLabel.removeChild(childLabel);
          price -= childPrice;
        }
        mainCheckbox.dataset.price = `${price}`;
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("div.product-installation").forEach((block) => setupBlock(block));
  });

  document.addEventListener("variant:update", function(e) {
    e.detail.data.html.querySelectorAll(":scope div.product-installation").forEach((block) => {
      const id = block.id;
      const old = document.querySelector(`#${id}`);
      if (old) {
        old.replaceWith(block);
        setupBlock(block);
       }
     });
   });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-upsells"] && !Shopify.designMode) return;
  try {
    function setupBlock(block) {
    const group = block.dataset.group;
    const exclusive = block.dataset.exclusive == "true";
    const form = block.querySelector(":scope input")?.form;
    if (!form) return;
    const formFields = buy_buttons_make_form_multi(form);
    const mainQuantity = formFields.quantity;
    if (exclusive) {
      const none = form.querySelector(`:scope input[name='${group}-none']`);
      const radios = form.querySelectorAll(`:scope input[name='items[${group}][id]']`);
      const quantity = form.querySelector(`:scope input[name='${group}[quantity]']`);
      const parentKey = form.querySelector(`:scope input[name='${group}[parent_id]']`);
      none.addEventListener("change", function () {
        quantity.name = `${group}-none`;
        parentKey.name = `${group}-none`;
        quantity.value = 0;
        radios.forEach((radio) => radio.checked = false);
      });
      radios.forEach((radio) => {
        radio.addEventListener("change", (e) => {
          quantity.name = `items[${group}][quantity]`;
          parentKey.name = `items[${group}][parent_id]`;
          quantity.value = mainQuantity.value;
          none.checked = false;
        });
      });
      document.addEventListener("quantity-selector:update", (e) => {
        if (e.target == mainQuantity) quantity.value = e.detail.quantity;
      });
      quantity.value = mainQuantity.value;
    } else {
      const checkboxes = document.querySelectorAll(`input[name^='${group}-']`);
      checkboxes.forEach((cb) => {
        const quantity = cb.nextElementSibling;
        cb.addEventListener("change", function(e) {
          if (cb.checked) quantity.value = mainQuantity.value;
          else quantity.value = 0;
        });
      document.addEventListener("quantity-selector:update", (e) => {
        if (cb.checked && e.target == mainQuantity)
          quantity.value = e.detail.quantity;
        });
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("div.product-upsells").forEach((block) => setupBlock(block));
  });

  document.addEventListener("variant:update", function(e) {
    e.detail.data.html.querySelectorAll(":scope div.product-upsells").forEach((block) => {
      const id = block.id;
      const old = document.querySelector(`#${id}`);
      if (old) {
        old.replaceWith(block);
        setupBlock(block);
      }
    });
  }, true); // run in capture phase - before install block
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sticky"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".sticky-block").forEach((e) => {
    const hideWhenVisible = document.querySelector(e.dataset.hideWhenVisible);
    const threshold = parseFloat(e.dataset.hideThreshold);
    if (hideWhenVisible) {
      const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              e.classList.add("hidden");
            } else {
              e.classList.remove("hidden");
            }
          });
        },
        { threshold }
      );
      observer.observe(hideWhenVisible);
    } else {
      e.classList.remove("hidden");
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
